export const language: any = {
  title: "Zutaten",
  select_all: "Alle auswählen",
  deselect_all: "Alle abwählen",
  add: "Zutaten hinzufügen",
  add_title: "Bitte wählen Sie, wie Sie die Zutaten hinzufügen möchten.",
  add_by_list: "Zutaten hinzufügen",
  add_total: "Insgesamt {number} Zutaten hinzufügen",
  selecting: "Gesamtzutaten",
  filter_title: "Sortieroptionen",
  filter_newest: "Neueste",
  filter_oldest: "Älteste",
  filter_alphabet: "Alphabetische Reihenfolge",
  get_recipe: "KI-Kochvorschläge erhalten",
  search_placeholder: "Bitte geben Sie Ihren Suchbegriff ein.",
  nodata: "Keine Zutaten verfügbar.",
  request: "Zutaten hinzufügen",
  recipe_title: "Empfohlene Gerichte",
  option: {
    title: "Option wählen",
    desc: "Die Auswahl einer Option ist nicht erforderlich.",
    complete: "Fertig",
    reset: "Zurücksetzen"
  },
  msg: {
    msg_7: "Möchten Sie die ausgewählten Zutaten hinzufügen?",
    msg_8: `
      <p>Möchten Sie die ausgewählten Zutaten hinzufügen?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> sind ausgeschlossen, da sie bereits in den vorhandenen Zutaten enthalten sind.)</p>
    `,
    msg_9: "Möchten Sie die ausgewählten Zutaten Ihrem Einkaufswagen hinzufügen?",
    msg_10: `
      <p>Möchten Sie die ausgewählten Zutaten Ihrem Einkaufswagen hinzufügen?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> sind ausgeschlossen, da sie bereits in den vorhandenen Zutaten enthalten sind.)</p>
    `,
    confirm: "Hinzufügen",
    cancel: "Abbrechen",
    not_ingredient: "Es scheint, dass der eingegebene Inhalt keine Kochzutat ist.<br />Bitte überprüfen Sie dies erneut.",
    ai_failed: "Beim Eingeben der Zutat ist ein Fehler aufgetreten.<br />Bitte versuchen Sie es später erneut.",
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> sind ausgeschlossen, da sie bereits in den vorhandenen Zutaten enthalten sind.)`
  },
  history: "Bildanalyse-Verlauf",
  myIngredient: "Meine Zutaten",
  history_no_data: "Kein Verlauf verfügbar",
  history_take_photo: "Foto aufnehmen oder auswählen"
}
